/**
 * @generated SignedSource<<b40083903bac6ae094ef58702847a09a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IntegrationAdminHRProviderListItem_Store$data = {
  readonly employeeScheduleTypes: ReadonlyArray<{
    readonly assignedTeams: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly id: string;
  }>;
  readonly " $fragmentType": "IntegrationAdminHRProviderListItem_Store";
};
export type IntegrationAdminHRProviderListItem_Store$key = {
  readonly " $data"?: IntegrationAdminHRProviderListItem_Store$data;
  readonly " $fragmentSpreads": FragmentRefs<"IntegrationAdminHRProviderListItem_Store">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IntegrationAdminHRProviderListItem_Store",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeScheduleType",
      "kind": "LinkedField",
      "name": "employeeScheduleTypes",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "assignedTeams",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};
})();

(node as any).hash = "9dc1ead7d2f6e37b23a8655aff0f0911";

export default node;
